import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { testIds } from "@/constants/testIds/b2b";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const u = await login(email.trim(), password);
      toast.success(`Welcome back${u.contact_name ? `, ${u.contact_name}` : ""}`);
      const to = loc.state?.from || (u.role === "admin" ? "/admin" : "/dashboard");
      nav(to, { replace: true });
    } catch (e) {
      setErr(e?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page-card" data-testid="login-page">
      <div className="max-w-md mx-auto px-4 md:px-6 py-16">
        <p className="text-[11px] uppercase tracking-[0.15em] text-muted-foreground mb-2">Wholesale portal</p>
        <h1 className="text-2xl md:text-3xl font-semibold mb-1">Sign in</h1>
        <p className="text-sm text-muted-foreground mb-8">Access your buyer dashboard, build orders, and manage invoices.</p>

        <form onSubmit={submit} className="space-y-4">
          <Field label="Email">
            <input
              data-testid={testIds.loginEmail}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              className="w-full px-3 py-2.5 text-sm border border-border rounded focus:border-primary"
            />
          </Field>
          <Field label="Password">
            <input
              data-testid={testIds.loginPassword}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              className="w-full px-3 py-2.5 text-sm border border-border rounded focus:border-primary"
            />
          </Field>
          {err && <p className="text-sm text-destructive" data-testid={testIds.loginError}>{err}</p>}
          <button
            data-testid={testIds.loginSubmit}
            type="submit"
            disabled={busy}
            className="w-full py-2.5 rounded bg-primary text-primary-foreground text-sm font-medium hover:opacity-90 disabled:opacity-50"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
          <p className="text-sm text-center">
            <Link to="/forgot-password" className="text-muted-foreground hover:text-foreground underline" data-testid={testIds.loginForgotPassword}>
              Forgot password?
            </Link>
          </p>
          <p className="text-sm text-center text-muted-foreground pt-2">
            New buyer?{" "}
            <Link to="/register" className="text-primary underline" data-testid="login-go-register">
              Apply for wholesale access
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <label className="text-[11px] uppercase tracking-[0.12em] text-muted-foreground block mb-1.5">{label}</label>
      {children}
    </div>
  );
}
